<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title fw-bold">{{ getHeader(selectedDatasetType.label)}}</h4>
        <button type="button" class="btn-close" (click)="cancel()"></button>
    </div>
    <div class="modal-body">
        <form #dtForm="ngForm">
            <div class="row mb-3">
                <div class="col-sm-6 pe-0">
                    <input type="checkbox" id="loadTemplateCheckbox" [(ngModel)]="isDropDownTemplateChecked"
                           name="loadTemplateCheckbox" class="form-check-input"/>
                    <label class="form-label fw-bold ms-2" for="loadTemplateCheckbox" jhiTranslate="study-editor.subobservation-modal.load-from-template"> Load dataset settings from template</label>
                </div>
                <div class="col-sm-6">
                    <select id="subObsTemplate" name="subObsTemplate"
                            (change)="changeTemplate()"
                            [(ngModel)]="selectedSubObsDataset" class="form-select"
                            [disabled]="!isDropDownTemplateChecked">
                        <option *ngFor="let template of templateDatasets" [ngValue]="template">
                            {{ template.datasetName }}
                        </option>
                        <option [ngValue]="null" jhiTranslate="global.please.choose">Please Choose</option>
                    </select>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-sm-6 pe-0">
                    <label class="form-label fw-bold"><span jhiTranslate="study-editor.subobservation-modal.dataset-name" [translateValues]="{param: selectedDatasetType.name}"></span><span
                            class="text-danger">*</span></label>
                </div>
                <div class="col-sm-6">
                    <input type="text" name="name" [(ngModel)]="datasetName" maxlength="100"
                           pattern="^[a-zA-Z0-9\s(\\/:*?&quot;&lt;&gt;|.)]*$"
                           class="form-control" required #nameField="ngModel"/>
                </div>
                <div class="col-sm-12 pt-2">
                    <div class="text-danger" *ngIf="(dtForm.submitted || nameField.touched) && nameField.errors">
                        <p *ngIf="nameField.errors?.['required']" jhiTranslate="study-editor.subobservation-modal.required.dataset-name">Name for (plants/quadrats/time series/custom)* dataset must be provided</p>
                        <p *ngIf="nameField.errors?.['pattern']" jhiTranslate="study-editor.subobservation-modal.pattern.dataset-name">Name for dataset should contain numbers, letter, spaces and \ / : * ? " < > |.</p>
                        <p *ngIf="nameField.errors?.['maxlength']" jhiTranslate="study-editor.subobservation-modal.maxlength.dataset-name">Name for dataset must not exceed 100 characters</p>
                    </div>
                </div>
            </div>
            <div class="row mb-3" [ngClass]="{'has-error': subObsUnitsField?.invalid}">
                <div class="col-sm-10">
                    <label class="form-label fw-bold"><span jhiTranslate="study-editor.subobservation-modal.maxNum.parent.unit" [translateValues]="{param1: selectedDatasetType.alias, param2: maxSubObservationParentUnit}"></span>
                        <span class="text-danger">*</span></label>
                </div>
                <div class="col-sm-2">
                    <input type="number" name="SubObservationUnits" [(ngModel)]="numberOfSubObservationUnits"
                           [min]="1" [max]="maxSubObservationParentUnit"
                           class="form-control" required #subObsUnitsField="ngModel"/>
                </div>
                <div class="col-sm-12">
                    <div class="text-danger" *ngIf="(dtForm.submitted || subObsUnitsField.touched) && subObsUnitsField.errors">
                        <p *ngIf="subObsUnitsField.errors?.['min'] || subObsUnitsField.errors?.['max']" jhiTranslate="study-editor.subobservation-modal.error.subObsNum.minmax"
                           [translateValues]="{param:maxSubObservationParentUnit}">
                            The number of sub-observations per parent unit should not be lower than 1 or greater than {{ maxSubObservationParentUnit }}
                        </p>
                        <p *ngIf="subObsUnitsField.errors?.['required']" jhiTranslate="study-editor.subobservation-modal.error.subObsNum.required">
                            The number of sub-observations per each parent unit to generate was not defined
                        </p>
                    </div>
                </div>
            </div>
            <div class="row mb-3" [ngClass]="{'has-error': variableField?.invalid}">
                <div class="report-type-section col-12" style="height: 30px;">
                    <label class="form-label fw-bold">
                        {{ 'study-editor.subobservation-modal.choose.variable' | translate: {param: selectedDatasetType.alias} }}: <span class="text-danger">*</span></label>
                    <span class="fa-solid fa-circle-question help-icon ms-3"
                          [ngbTooltip]="selectedVariable?.description"></span>
                </div>
                <div class="report-type-section col-6-md col-md-6">
                    <select id="variableDatasetBuilder" name="selectVariableDatasetBuilder"
                            [(ngModel)]="selectedVariable"
                            class="form-select"  #variableField="ngModel" required>
                        <option *ngFor="let variable of variables" [ngValue]="variable">
                            {{variable.name}}
                        </option>
                        <option [ngValue]="null" jhiTranslate="global.please.choose">Please Choose</option>
                    </select>
                </div>
                <div class="col-sm-12 pt-2">
                    <div class="text-danger" *ngIf="(dtForm.submitted || variableField.touched) && variableField.errors?.['required']">
                        <p jhiTranslate="study-editor.subobservation-modal.error.subObsNumVar.required">A variable to number the sub-observations units for data collection should be specified</p>
                    </div>
                </div>
            </div>
            <div class="row mb-3" [ngClass]="{'has-error': isEmptySelection}">
                <div class="col-xs-12 col-md-12">
                    <label class="form-label fw-bold"><span jhiTranslate="study-editor.subobservation-modal.select.environments"
                                                            [translateValues]="{param:selectedDatasetType.name}"></span><span class="text-danger">*</span></label>
                </div>
                <div class="col-sm-12 pt-2">
                    <div class="text-danger" *ngIf="isEmptySelection">
                        <p jhiTranslate="study-editor.subobservation-modal.select.environments.error.empty">The environment(s) to which you would like to apply the sub-observations must be selected</p>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col">
                    <jhi-study-instances-table-selector [studyInstanceItems]="studyInstanceItems" [selectAll]="true"></jhi-study-instances-table-selector>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-hidden="true"
                        (click)="cancel()" jhiTranslate="back">Back</button>
                <button type="submit" class="btn btn-primary" (click)="saveDataset()">
                    <span jhiTranslate="save">Save</span>
                    <span *ngIf="submitted" class="throbber-btn-wrapper">
                            <span class="throbber throbber-btn throbber-white"></span>
                        </span>
                </button>
            </div>
        </form>
    </div>
</div>
